/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_TADRSInstruction_ExportTADRSInstructionResponseDto } from '../models/Wealthlane_AwardService_Dtos_TADRSInstruction_ExportTADRSInstructionResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaDrsInstructionService {

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTaDrsInstructionExportTAdrsInstruction(
        requestBody?: Wealthlane_AwardService_Dtos_TADRSInstruction_ExportTADRSInstructionResponseDto,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/ta-drs-instruction/export-tADRSInstruction',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTaDrsInstructionToTransferAllocate(
        requestBody?: Array<string>,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/ta-drs-instruction/to-transfer-allocate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
